import { CRYPTO_PROVIDER_ATTRIBUTION } from './providerAttribution';
import type { CryptoFundingProvider } from './providerAttribution';

export const CRYPTO_PROVIDER_ATTRIBUTION_TEST_ID =
  'crypto_provider-attribution';
export const CRYPTO_PROVIDER_NAME_TEST_ID =
  'crypto_provider-attribution_provider-label';
export const CRYPTO_PROVIDER_TERMS_TEST_ID =
  'crypto_provider-attribution_terms-link';

type CryptoProviderAttributionProps = {
  provider: CryptoFundingProvider;
};

export const CryptoProviderAttribution = ({
  provider
}: CryptoProviderAttributionProps) => {
  const { displayName, termsUrl } = CRYPTO_PROVIDER_ATTRIBUTION[provider];

  return (
    <footer
      className="mt-auto flex shrink-0 flex-wrap items-center justify-center gap-x-4 gap-y-1 py-3 text-xs text-content-secondary"
      data-testid={CRYPTO_PROVIDER_ATTRIBUTION_TEST_ID}
    >
      <span data-testid={CRYPTO_PROVIDER_NAME_TEST_ID}>
        Powered by {displayName}
      </span>
      <a
        className="cursor-pointer underline hover:text-content-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        href={termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${displayName} Terms & Conditions (opens in a new tab)`}
        data-testid={CRYPTO_PROVIDER_TERMS_TEST_ID}
      >
        Terms &amp; Conditions
      </a>
    </footer>
  );
};
